<div [ngStyle]="style">
  <app-navbar></app-navbar>

  <router-outlet></router-outlet>
</div>
